import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';
import { Any } from 'json2typescript';
import { WeekCard } from './week-card';
import { TotalByProject } from '../totalByProject';
import { Editions } from './editions';

export type TimeCardType = 'WORK' | 'PAID_BREAK' | 'UNPAID_BREAK' | 'VACATION';

@JsonObject('model.time_card.TimeCard')
export class ReportCard extends AbstractModel {

    @JsonProperty(String, 'start')
    start?: string;

    @JsonProperty(String, 'finish')
    finish?: string;

    @JsonProperty(String, 'finishClosed')
    finishClosed?: string;

    @JsonProperty(User, 'user')
    user?: User;

    // TODO FIX THIS
    @JsonProperty(Any, 'workDuration')
    workDuration?: any;

    @JsonProperty(Any, 'paidBreaksDuration')
    paidBreaksDuration?: any;

    @JsonProperty(Any, 'unpaidBreaksDuration')
    unpaidBreaksDuration?: any;

    @JsonProperty(Any, 'overtimeWorkDuration')
    overtimeWorkDuration?: any;

    @JsonProperty(Number, 'payableDuration')
    payableDuration?: number;

    @JsonProperty(Number, 'regularWorkDuration')
    regularWorkDuration?: number;

    @JsonProperty(Boolean, 'approved')
    approved?: boolean;

    @JsonProperty([WeekCard], 'weeks')
    weeks?: WeekCard[];

    @JsonProperty([TotalByProject], 'totalByProject')
    totalByProject?: TotalByProject[];

    @JsonProperty([Editions], 'editions')
    editions?: Editions[];


}